import * as api from '../api'

export const test = ({commit, state}, params)=>{

};

export const mounted = ({commit}) =>{
    commit('storeMounted');
}

export const loginUser = ({commit}, username, password)=>{
    return new Promise(function(resolve, reject){
        api.loginUser(username, password)
        .then(data=>{
            commit('storeUser', {username:data.data.username, type:data.data.us_type});
            resolve({username:data.data.username, type:data.data.us_type, token: data.header});
        })
        .catch(()=>{reject()})
    })

}

export const logoutUser = ({commit})=>{
    return new Promise(function(resolve, reject){
        api.logoutUser()
            .then(()=>{
                commit('storeUser', {});
                resolve();
            })
            .catch(err=>reject(err))

    })
}

export const getUser = ({commit}) =>{
    return new Promise(function(resolve, reject){
        api.getUser()
            .then(data=>{
                if(data.username){
                    commit('storeUser', {username:data.username, userType:data.us_type});
                    return resolve();
                }
                return reject();
            })
    })
}

export const saveUser = ({commit}, user)=>{
    commit('storeUser', user);
}

export const getDays = ({commit})=>{
    var promise = new Promise(function(resolve, reject){
        var activeDays = {};
        api.getNoiseDays()
        .then(data=>{
            data.data.forEach(day=>{
                if(!activeDays[day]) activeDays[day] = {};
                activeDays[day].noise = true;
            });
            return activeDays;
        })
        .catch(err=>{
            console.log(err);
            return activeDays;
        })
        .then(activeDays=>{
             return api.getAudioDays()
            .then(data=>{
                data.data.forEach(day=>{
                    if(!activeDays[day]) activeDays[day] = {};
                    activeDays[day].audio = true;
                });
                return activeDays;
            })
        })
        .catch(err=>{
            console.log(err);
           return activeDays;
        })
        .then(activeDays=>{
            return api.getWeatherDays()
            .then(data=>{
                data.data.forEach(day=>{
                    if(!activeDays[day]) activeDays[day] = {};
                    activeDays[day].weather = true;
                });
                resolve(activeDays);
            })
        })
        .catch(err=>{
            console.log(err);
            resolve(activeDays);
        })
    })
    promise.then(activeDays=>{
        commit('storeDays', activeDays);
    })
}

export const getMeasurementsDays = ({commit,state})=>{
    return new Promise(function(resolve, reject){
        if(state.calendarQuery > 0) return
        state.calendarQuery = 1;
        api.getMeasurementsDays()
            .then(data=>{
                var activeDays = {};
                var noise = data.data.noise;
                if(noise){
                    noise.forEach(day=>{
                        if(!activeDays[day]) activeDays[day] = {};
                        activeDays[day].noise = true;
                    })
                }
                var audio = data.data.audio;
                if(audio){
                    audio.forEach(day=>{
                        if(!activeDays[day]) activeDays[day] = {};
                        activeDays[day].audio = true;
                    })
                }
                var weather = data.data.weather;
                if(weather){
                    weather.forEach(day=>{
                        if(!activeDays[day]) activeDays[day] = {};
                        activeDays[day].weather = true;
                    })
                }
                var video = data.data.video;
                if(video){
                    video.forEach(day=>{
                        if(!activeDays[day]) activeDays[day] = {};
                        activeDays[day].video = true;
                    })
                }
                var adio = data.data.adio;
                if(adio){
                    adio.forEach(day=>{
                        if(!activeDays[day]) activeDays[day] = {};
                        activeDays[day].adio = true;
                    })
                }
                commit('storeDays', activeDays);
                resolve(activeDays)
        })
    })

}

export const getDaysByType = ({commit},type)=>{
    return api.getDays(type);
};

export const getHoursByType = ({commit}, type, selectedDay)=>{
    return api.getArchiveHours(type, selectedDay);
};

export const getSelectedDayHours = ({commit}, selectedDay) =>{
    return new Promise(function(resolve, reject){
        api.getMeasurementsHours(selectedDay)
        .then(data=>{
            var activeHours = {values:[]};
            var noise = data.data.noise;
            if(noise){
                noise.forEach(hour=>{
                    if(!activeHours[hour]){
                         activeHours[hour] = {}
                         activeHours.values.push(hour);
                    }
                    activeHours[hour].noise = true;
                })
            }
            var audio = data.data.audio;
            if(audio){
                audio.forEach(hour=>{
                    if(!activeHours[hour]){
                        activeHours[hour] = {};
                        activeHours.values.push(hour);
                    }
                    activeHours[hour].audio = true;
                })
            }
            var weather = data.data.weather;
            if(weather){
                weather.forEach(hour=>{
                    if(!activeHours[hour]){
                        activeHours[hour] = {};
                        activeHours.values.push(hour);
                    }
                    activeHours[hour].weather = true;
                })
            }
            var video = data.data.video;
            if(video){
                video.forEach(hour=>{
                    if(!activeHours[hour]){
                        activeHours[hour] = {};
                        activeHours.values.push(hour);
                    }
                    activeHours[hour].video = true;
                })
            }
            var adio = data.data.adio;
            if(adio){
                adio.forEach(hour=>{
                    if(!activeHours[hour]){
                        activeHours[hour] = {};
                        activeHours.values.push(hour);
                    }
                    activeHours[hour].adio = true;
                })
            }
                activeHours.values.sort();
            commit('storeSelectedDayHours',activeHours);
            resolve(activeHours);
        })
        .catch(err=>{
            console.log(err);
            resolve({headers:[], data:[]});
        })
    });
}
export const setSelectedHour = ({commit}, hour, loading = false)=> commit('storeSelectedHour', {hour, loading});
export const setSelectedDay = ({commit}, day, loading = false) => commit('storeSelectedDay', {day,loading});
export const setSidebarVisible = ({commit}, visible) => commit('storeSidebarVisible', visible);


export const getStatus = ({commit}) =>{
    return api.getStatus()
        .then(response=>{
            commit('storeStatus', response.data);
        })
}

export const startAll = ({commit}) =>{
    return api.startAll()
        .then(()=>{
            commit('storeWeatherStatus', true)
            commit('storeNoiseStatus', true)
        })
}

export const stopAll = ({commit}) =>{
    return api.stopAll()
        .then(()=>{
            commit('storeWeatherStatus', false)
            commit('storeNoiseStatus', false)
        })
}

export const startWeather = ({commit}) =>{
    return api.startWeather()
        .then(_=>{
            commit('storeWeatherStatus', true)
        })
}

export const stopWeather = ({commit}) =>{
    return api.stopWeather()
        .then(_=>{
            commit('storeWeatherStatus', false)
        })
}

export const startNoise = ({commit}) =>{
    return api.startNoise()
        .then(_=>{
            commit('storeNoiseStatus', true)
        })
}

export const stopNoise = ({commit}) =>{
    return api.stopNoise()
        .then(_=>{
            commit('storeNoiseStatus', false)
        })
}

export const startAdio = ({commit}) =>{
    return api.startAdio()
        .then(_=>{
            commit('storeAdioStatus', true)
        })
}

export const stopAdio = ({commit}) =>{
    return api.stopAdio()
        .then(_=>{
            commit('storeAdioStatus', false)
        })
}
/* ADDED NEW STUFF */
/* ADDED NEW STUFF */
/* ADDED NEW STUFF */
/* ADDED NEW STUFF */
export const setNoise = ({commit}) => {
    return api.setNoise();
}
export const restartNoise = ({commit}) => {
    return api.restartNoise();
}
export const sdFormatNoise = ({commit}) => {
    return api.sdFormatNoise();
}
export const sdFreeNoise = ({commit}) => {
    return api.sdFreeNoise();
}
export const testOptions = ({commit}) => {
    return api.testOptions();
}

export const setWeather = ({commit}) => {
    return api.setWeather();
}

export const testEmail = ({commit},gr) => {
    return api.testEmail(gr);
}
export const ftpTestConn = ({commit},address,auth,user,pwd) => {
    return api.ftpTestConn(address,auth,user,pwd);
}

export const rebootSys = ({commit}) => {
    return api.rebootSys();
}


export const getFirmware = ({commit}) =>{
    return new Promise(function(resolve, reject){
        api.getFirmWare()
            .then(response=>{
                commit('storeFirmware', response.data);
                resolve(response.data);
            });
    });
}
/* ----------- */
/* ----------- */
/* ----------- */
/* ----------- */
export const getSystemStatus = ({commit}) =>{
    return new Promise(function(resolve, reject){
        api.getSystemStatus()
            .then(response=>{
                commit('storeSystemStatus', response.data);
            });
    });
}

export const getDailyData = ({commit}, type = 'noise', selectedDay, start, end)=>{
    return new Promise(function(resolve, reject){
        api.getDayData(type, selectedDay, start, end)
            .then(data=>{
                resolve(data);
            })
            .catch(err=>{
                console.log('Error getDailyData', err);
                reject(err);
            })
    });
}

export const getRealTimeData = ({commit}, type = 'noise', count) =>{
    return new Promise(function(resolve, reject){
        api.getRealTimeData(type,count)
            .then(data=>{
                resolve(data);
            })
            .catch(err=>{
                //console.log('Error getting real time data',err);
                resolve({headers:[], data:[]});
            })
    });
}

/*export const getDailyData = ({commit}, selectedDay, start, end) =>{
    return new Promise(function(resolve, reject){
        api.getDayNoise(selectedDay, start, end)
        .then(data=>{
            resolve(data);
        })
        .catch(err=>{
            console.log("1",err);
            resolve({headers:[], data:[]});
        })
    })
}*/


export const getHourlyData = ({commit}, type = 'noise', selectedHour, start, end) =>{
    return new Promise(function(resolve, reject){
        api.getData(type, selectedHour, start, end)
        .then(data=>{
            resolve(data);
        })
        .catch(err=>{
            reject(err);
        })
    });
}

/** AUDIO */
export const getRecDay = ({commit}, date)=>{
    return api.getRecDay(date);
}

export const getRecHour = ({commit}, date)=>{
    return api.getRecHour(date);
}

export const getAudioDay = ({commit},date) =>{
    return api.getAudioDay(date);
}

export const getAudioHour = ({commit}, date)=>{
    return api.getAudioHour(date);
}

/* VIDEO */
export const getVideoDay = ({commit}, date)=>{
    return api.getVideoDay(date);
}

export const getVideoHour = ({commit}, date)=>{
    return api.getVideoHour(date);
}


/* DOWNLOAD */

export const postFileAction=({commit}, action, type, data)=>{
    return api.postFileAction(action, type, data);
}

export const getFilesAction = ({commit}, type, data)=>{
    return api.getFilesAction(type, data);
}

export const setSelectedInterval = ({commit}, start, end, source) =>{
    var selectedInterval = {
        start: start,
        end:end,
        source:source
    }
    commit('storeSelectedInterval', selectedInterval);
}

export const setRealtimeEnabled  = ({commit}, enabled) =>{
    commit('storeRealtimeEnabled', enabled);
}

export const setDownloading = ({commit}, isDownloading) =>{
    commit('storeDownloading', isDownloading);
}
export const setDownloadingProgress = ({commit}, progress)=>{
    commit('storeDownloadingProgress', progress);
}

/*SETTINGS */
export const getLocalSettings = ({commit}) =>{
    return new Promise(function(resolve, reject){
        api.getDefaultLocalSettings()
            .then(settings=>{
                //commit('storeLocalSettings',settings);
                resolve(settings);
            })
    })
}
export const saveLocalSettings = ({commit}, localStorage, settings) =>{
    commit('storeLocalSettings', {localStorage:localStorage, settings:settings});
}
export const createUnsavedLocalSettings = ({commit})=>{
    commit('createUnsavedLocalSettings')
}

export const getSettings = ({commit})=>{
    return new Promise(function(resolve, reject){
        api.getSettings()
            .then(settings=>{
                commit('storeSettings', settings);
                resolve(settings);
            });
    });
}

export const saveSettings = ({commit},settings)=>{
    return api.saveSettings(settings);
}


export const startAudioStream = ({commit}) =>{
    return api.startAudioStream();
}

export const stopAudioStream = ({commit}) =>{
    return api.stopAudioStream();
}

export const startAudioRecording = ({commit})=>{
    return api.startAudioRecording();
}

export const stopAudioRecording = ({commit}) =>{
    return api.stopAudioRecording();
}

export const increaseVolume = ({commit}) =>{
    return api.increaseVolume();
}

export const decreaseVolume = ({commit})=>{
    return api.decreaseVolume();
}

export const formatVideoSD = ({commit}) =>{
    return api.formatVideoSD();
}

export const setVideo = ({commit}) =>{
    return api.setVideo();
}

export const logsList = ({commit}) =>{
    return api.logsList();
}

export const getLogs = ({commit}, type) =>{
    return api.getLogs(type);
}

export const deleteOnInterval = ({commit}, del_date)=>{

    var from =  del_date.From;
    var to = del_date.To;
    var values = del_date.Values;
    from.setHours(12);
    to.setHours(12);
    return api.deleteOnInterval(from, to, values);
}

export const setScreenSize = ({commit}, size)=>{
    commit('storeScreenSize', size);
}

export const updateStatisticsSettings = ({commit}, settings) =>{
    commit('updateStatisticsSettings', settings)
}

export const updateStartstopSettings = ({commit}, settings) =>{
    commit('updateStartstopSettings', settings);
}

//MARKERS

export const getMarkersDay = ({commit}, request)=>{
    return api.getMarkersDay(request.from);
}
export const getMarkersHour = ({commit}, request)=>{
    return api.getMarkersHour(request.from);
}

export const setMarker = ({commit}, request)=>{
    return api.setMarker(request);
}

export const deleteMarker = ({commit}, request)=>{
    return api.deleteMarker(request);
}

export const saveMarkerNote = ({commit}, request)=>{
    return api.setMarkerNote(request);
}

export const getDefaultMarkers = ({commit}) =>{
    return api.getDefaultMarkers()
      .then(response=>{
         let data = response.data;

         let header = data.headers;
         if (header) {
             let hID = header.indexOf('ID');
             let hName = header.indexOf('Name');
             let hColor = header.indexOf('Color');
             let hType = header.indexOf('Type');
         } else {
            let hID = 0;
            let hName = 0;
            let hColor = 0;
            let hType = 0;
         }
         let markers = [];
        if (data.data) {
             data.data.forEach(m=>{
                markers.push({
                  id: m[hID],
                  name: m[hName],
                  color: m[hColor],
                  type: m[hType]
                })
             })
         }

         return markers;
      })
}

export const getDailyNote = ({commit}, request) =>{
    return api.getDailyNote(request)
}



// WEBPACK FOOTER //
// ./src/store/actions.js